import { ChannelPayloadFilter, ViewStream } from "spyne";

const {
  CodePlaygroundExamplesNestingTraits,
} = require("traits/code-playground-examples-nesting-traits.js");
const NestingChildTmpl = require("../example-templates/disposing-nesting-example-node.tmpl.html");

export class NestingChildView extends ViewStream {
  constructor(props = {}) {
    props.traits = CodePlaygroundExamplesNestingTraits;
    props.data ??= { childType: "root" };
    props.addRandom ??= false;
    props.childTypeArr ??= ["child", "grandchild", "ggc", "ggc2", "ggc3"];
    props.class = `branch ${props.data.childType}`;
    props.template = NestingChildTmpl;
    super(props);
  }

  addActionListeners() {
    const payloadFilter = new ChannelPayloadFilter({
      payload: (p) =>
        p.childType === this.props.data.childType || p.childType === "reset",
      srcElement: (p) =>
        p.vsid === this.props.vsid || p.id === "nesting-example",
    });
    return [
      [
        "CHANNEL_UI_CLICK_EVENT",
        "codePlayground$OnNestingEvent",
        payloadFilter,
      ],
    ];
  }
  broadcastEvents() {
    return [["button", "click"]];
  }

  onRendered() {
    this.addChannel("CHANNEL_UI");
    this.codePlayground$RandomAddChildCheck();
  }
}
